import type { StatusTransMap } from "components/table";
import { ScenarioNodeType, ScenarioStatus } from "types/scenario";

export const NODE_API_PENDING_MESSAGE = "API node sẽ được cập nhật sau";

export const NODE_LINK_ERROR = {
  ancestor: "Không chọn node nằm phía trên Choice",
  branch: "Không chọn node đã thuộc nhánh khác",
} as const;

export const NODE_KEY_ERROR = "Key node không được trống hoặc trùng";

export const BRANCH_LABELS = ["A", "B", "C", "D", "E", "F"] as const;

export const getBranchLabel = (index: number) => BRANCH_LABELS[index] ?? String(index + 1);

export const getBranchTone = (index: number) => (BRANCH_LABELS[index] ?? "A").toLowerCase();

export const NODE_TYPE_OPTIONS: { value: ScenarioNodeType; label: string }[] = [
  { value: ScenarioNodeType.Choice, label: "Choice — Người dùng chọn" },
  { value: ScenarioNodeType.Message, label: "Message — Bot phản hồi" },
  { value: ScenarioNodeType.Input, label: "Input — Thu thập dữ liệu" },
  { value: ScenarioNodeType.End, label: "End — Kết thúc" },
];

export const NODE_ADD_OPTIONS: { type: ScenarioNodeType; label: string; desc: string }[] = [
  { type: ScenarioNodeType.Message, label: "Message", desc: "Bot phản hồi" },
  { type: ScenarioNodeType.Input, label: "Input", desc: "Thu thập dữ liệu" },
  { type: ScenarioNodeType.Choice, label: "Choice", desc: "Rẽ nhánh theo lựa chọn" },
  { type: ScenarioNodeType.End, label: "End", desc: "Kết thúc luồng" },
];

export const SCENARIO_STATUS_TRANS: StatusTransMap<ScenarioStatus> = {
  [ScenarioStatus.On]: {
    label: "Đang bật",
    color: "#08764d",
    bgcolor: "#e7f8f1",
  },
  [ScenarioStatus.Draft]: {
    label: "Nháp",
    color: "#a55b00",
    bgcolor: "#fff4df",
  },
  [ScenarioStatus.Off]: {
    label: "Tắt",
    color: "#647286",
    bgcolor: "#eef1f4",
  },
};
